<template>
  <el-card shadow="never" class="lad-fliths--card">
    <div slot="header" class="flight-card--header">
      <el-tag size="medium" type="success" class="round-flight">
        <i class="el-icon-price-tag" />
        <span v-if="flightsReturn.length">{{
          $t(`flights.round_flight`)
        }}</span>
        <span v-else>{{ $t(`flights.oneway_flight`) }}</span>
      </el-tag>

      <el-tag size="medium" type="success" class="class-flight">
        <i class="el-icon-price-tag" />
        <span>{{ $t('flights.cabins.' + flightsGo[0].fare_category) }}</span>
      </el-tag>

      <template>
        <h3>{{
          `${flightsGo[0].cityFrom} - ${flightsGo[flightsGo.length - 1].cityTo}`
        }}</h3>
        <span></span>
        <h3
          >{{ tickets }} <i class="fas fa-ticket-alt" />
          {{ holdBags ? holdBags : '' }}
          <i v-if="holdBags" class="fas fa-suitcase-rolling" />
          {{ handBags ? handBags : '' }}
          <i v-if="handBags" class="fas fa-shopping-bag" />
        </h3>
        <!-- <h3><i class="el-icon-info"></i></h3> -->
      </template>
    </div>

    <div class="flight-card--body fligth-go">
      <div class="flight-card--body-left">
        <h5 class="flight-time departure-time">
          {{ $dayjs(flightsGo[0].local_arrival).utc() | ladFnStrDate('HH:mm') }}
        </h5>
        <p class="flight-date departure-date">
          {{
            $dayjs(flightsGo[0].local_arrival).utc()
              | ladFnStrDate('MMM DD, YYYY')
          }}
        </p>
      </div>

      <div class="flight-card--body-middle">
        <p>{{ flightsGo[0].operating_flight_no }}</p>
        <el-divider>
          <i class="fas fa-plane" />
        </el-divider>
        <p>{{ $dayjs(timeFlightGo).format('HH:mm') }}hrs</p>
      </div>

      <div class="flight-card--body-right">
        <h5 class="flight-time arrival-time">{{
          $dayjs(flightsGo[flightsGo.length - 1].local_arrival).utc()
            | ladFnStrDate('HH:mm')
        }}</h5>
        <p class="flight-date arrival-date">{{
          $dayjs(flightsGo[flightsGo.length - 1].local_arrival).utc()
            | ladFnStrDate('MMM DD, YYYY')
        }}</p>
      </div>
      <div class="flight-card--body-middle">
        <el-tag v-if="flightsGo.length > 1" @click="handleOpenScales">
          {{ $t('flights.scales.num', { num: flightsGo.length }) }}</el-tag
        >
      </div>
    </div>

    <div v-if="flightsReturn.length" class="flight-card--body fligth-back">
      <div class="flight-card--body-left">
        <h5 class="flight-time departure-time">{{
          $dayjs(flightsReturn[flightsReturn.length - 1].local_arrival).utc()
            | ladFnStrDate('HH:mm')
        }}</h5>
        <p class="flight-date departure-date">{{
          $dayjs(flightsReturn[flightsReturn.length - 1].local_arrival).utc()
            | ladFnStrDate('MMM DD, YYYY')
        }}</p>
      </div>

      <div class="flight-card--body-middle">
        <p>{{ flightsReturn[flightsReturn.length - 1].operating_flight_no }}</p>
        <el-divider>
          <i class="fas fa-plane fa-flip-horizontal" />
        </el-divider>
        <p>{{ $dayjs(timeFlightReturn).format('HH:mm') }}hrs</p>
      </div>

      <div class="flight-card--body-right">
        <h5 class="flight-time arrival-time">{{
          $dayjs(flightsReturn[0].local_arrival).utc() | ladFnStrDate('HH:mm')
        }}</h5>
        <p class="flight-date arrival-date">{{
          $dayjs(flightsReturn[0].local_arrival).utc()
            | ladFnStrDate('MMM DD, YYYY')
        }}</p>
      </div>
      <div class="flight-card--body-middle">
        <el-tag v-if="flightsReturn.length > 1" @click="handleOpenScales">{{
          $t('flights.scales.num', { num: flightsReturn.length })
        }}</el-tag>
      </div>
    </div>

    <div class="flight-card--footer">
      <div>
        <LadImage
          v-for="(airline, i) in item.airlines"
          :key="i"
          :src="airline.urlLogo"
          :title="airline.name"
        />
      </div>
      <span></span>
      <div>
        <LadPrice
          :price="item.price"
          :currency="currency"
          :promotions="promotions"
        />
      </div>
    </div>

    <el-button-group class="flight-card--cta">
      <el-button
        type="success"
        class="btn--btn-layaway"
        @click="goToFastCheckout"
        >{{ $t('flights.booking.reserve') }}</el-button
      >

      <!-- <el-button type="text" class="btn--book-now"
        >botton add to cart</el-button
      > -->
    </el-button-group>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadFlightAvaCard',
  props: {
    itemKey: { type: Number, require: true, default: -1 },
    item: { type: Object, require: true, default: () => ({}) },
    availability: { type: Object, require: true, default: () => ({}) },
    promotions: { type: Array, default: () => [] },
  },
  data() {
    return {
      base: 'experience.availability.modal.item',
      format: 'YYYY-MM-DD HH:mm:ss',
    }
  },
  computed: {
    ...mapState('kiwi', {
      search: (state) => state.search,
    }),
    ...mapState('settings', ['currency']),
    tickets() {
      return this.search.adults + this.search.children + this.search.infants
    },
    holdBags() {
      return this.search.adultHoldBag + this.search.childHoldBag
    },
    handBags() {
      return this.search.adultHandBag + this.search.childHandBag
    },
    flightsGo() {
      const data = this.item.route.filter((flight) => !flight.return)
      return data
    },
    flightsReturn() {
      return this.item.route.filter((flight) => flight.return)
    },
    timeFlightGo() {
      return this.flightsGo.reduce(
        (acc, curr) => acc + this.$dayjs(curr.momutc_arrival).utc(),
        0
      )
    },
    timeFlightReturn() {
      return this.flightsReturn.reduce(
        (acc, curr) => acc + this.$dayjs(curr.momutc_arrival).utc(),
        0
      )
    },
    layawayAmount() {
      return {
        amount: this.$options.filters.ladFnCurrency(
          this.availability.layaway,
          this.currency
        ),
      }
    },
    offsetHours() {
      const diff = this.endingDatetime.diff(this.startDateTime, 'minute')
      const div = diff / 60
      const hours = parseInt(div)

      return `${parseInt(hours)}h ${parseInt((div - hours) * 60)}m`
    },
    ...mapState('settings', ['currency']),
  },
  methods: {
    handleOpenScales() {
      this.$emit('scales', this.itemKey)
    },
    async goToFastCheckout() {
      try {
        const { status, data } = await this.$axios.post(
          '/api/v1.5/kiwi/create-flights',
          {
            search: this.search,
            dataFlight: this.item,
          }
        )

        if (status === 'success') {
          this.$store.dispatch('shopping-cart/setFastCheckout', {
            type: 'flight',
            item: {
              availability_uuid: data.availability_uuid,
              uuid: data.uuid,
              availability_id: data.availability_id,
              qty: 1,
              unit: 1,
              open: false,
              date: null,
              departure_date_code: this.item.code,
              parent: { uuid: null, index: null },
            },
          })
          const extras = []
          if (data.extras.holdBags.qty > 0) extras.push(data.extras.holdBags)
          if (data.extras.infants.qty > 0) extras.push(data.extras.infants)
          if (data.extras.children.qty > 0) extras.push(data.extras.children)

          extras.forEach((extra) => {
            this.$store.dispatch('shopping-cart/addExtra', {
              type: 'extra',
              item: {
                uuid: extra.uuid,
                qty: extra.qty,
                is_new: extra.is_new,
                parent: {
                  uuid: extra.parent.uuid,
                },
                sale_price: extra.sale_price,
              },
            })
          })
        }
      } catch (error) {}

      this.$router.push({
        name: 'checkout-layaway',
        params: {
          type: 'fast-checkout',
        },
      })
    },
  },
}
</script>

<style lang="scss">
.lad-fliths--card {
  margin-top: 20px;
  position: relative;
  border-radius: 0;

  .el-card__header {
    padding: 10px 15px;
    border: 0;

    h3 {
      margin-top: 25px;
    }
  }
  .el-card__body {
    padding: 0;
  }

  .el-tag {
    cursor: pointer;
  }

  .round-flight {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0;
  }

  .class-flight {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0;
  }

  .flight-card--body {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-gap: 10px;
    align-items: center;
    padding: 10px 15px 0;

    .flight-time {
      font-size: 1.2em;
      line-height: 1.8;
      margin: 0;
    }

    .flight-date {
      margin: 0;
      font-style: italic;
      font-size: 0.9em;
    }

    &-middle {
      .el-divider {
        margin: 10px 0;

        .el-divider__text {
          padding: 0 5px;
        }

        &::before,
        &::after {
          content: '';
          display: inline-block;
          position: absolute;
          padding: 1px;
          top: -5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: white;
          border: 1px solid #e6e8ed;
        }

        &::before {
          left: 0;
        }

        &::after {
          right: 0;
        }
      }

      p {
        text-align: center;
        color: #b5b5b5;
        font-weight: 500;
        font-size: 0.9em;
        margin: 0;
        line-height: 1.8;
      }
    }

    &-right {
      text-align: right;
    }
  }

  .flight-card--footer {
    display: grid;
    grid-template-columns: 120px 1fr auto;
    grid-gap: 10px;
    align-items: center;
    border-top: 2px dashed #dcdfe6;
    margin-top: 15px;
    padding: 10px 15px;
    background-color: #f9fafb;

    .wrapper--price-top {
      text-align: right;
      padding-top: 0;
      font-size: 0.7em;
    }

    .price--price {
      font-size: 1.5em;
      font-weight: 400;
    }

    .price-content--left {
      font-size: 0.8em;
    }

    .price-content--right {
      font-size: 0.8em;

      .price--currency {
        margin-top: 0;
      }
    }

    .wrapper--price-bottom {
      text-align: right;
      padding: 0;
    }
    .price--unit {
      font-size: 0.9em;
      font-style: italic;
    }

    img {
      max-width: 24px;
      margin: 3px;
    }
  }

  .el-button-group.flight-card--cta {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1px;

    &::before,
    &::after {
      display: none;
    }

    .el-button {
      border-radius: 0;
      border: 0;

      &--text {
        border-top: 1px solid #ebeef2;
      }
    }
  }
}
</style>
